import { useId } from "react";

// Subtle, hand-drawn botanical creeper motif. Tiles a gentle vine with small leaves.
// `light` renders it in soft lavender for use over dark (navy) backgrounds.
export const Creeper = ({ className = "", vertical = false, light = false }) => {
  const raw = useId().replace(/[:]/g, "");
  const pid = `vine-${raw}`;
  const stroke = light ? "#C9C0D3" : "#1B2A4A";
  const strokeOp = light ? 0.35 : 0.16;
  const leafOp = light ? 0.22 : 0.09;
  return (
    <svg className={className} aria-hidden="true" role="presentation">
      <defs>
        <pattern
          id={pid}
          width="180"
          height="22"
          patternUnits="userSpaceOnUse"
          patternTransform={vertical ? "rotate(90)" : undefined}
        >
          <g stroke={stroke} strokeWidth="1" fill="none" strokeLinecap="round" opacity={strokeOp}>
            <path d="M0 11 Q 22 3 45 11 T 90 11 T 135 11 T 180 11" />
            <path d="M30 8 q 6 -8 13 -5" />
            <path d="M105 14 q 6 8 13 5" />
            <path d="M150 8 q 5 -6 11 -4" />
          </g>
          <g fill={stroke} opacity={leafOp}>
            <path d="M43 3 q 7 -1 8 5 q -7 1 -8 -5 z" />
            <path d="M118 19 q 7 1 8 -5 q -7 -1 -8 5 z" />
            <path d="M161 4 q 6 -1 7 4 q -6 1 -7 -4 z" />
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${pid})`} />
    </svg>
  );
};
